__turbopack_context__.v({
  "active": "ProducerCard-module-scss-module__r0kwda__active",
  "button": "ProducerCard-module-scss-module__r0kwda__button",
  "energy-source-tag": "ProducerCard-module-scss-module__r0kwda__energy-source-tag",
  "image": "ProducerCard-module-scss-module__r0kwda__image",
  "producer-card": "ProducerCard-module-scss-module__r0kwda__producer-card",
  "status": "ProducerCard-module-scss-module__r0kwda__status",
});
